import * as Yup from 'yup';
import PropTypes from 'prop-types';

export const CustomerPropTypes = PropTypes.shape({
    _id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    company: PropTypes.string,
    designation: PropTypes.string,
    active: PropTypes.bool,
});

export const CustomerDefaultProps = {
    _id: undefined,
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    company: '',
    designation: '',
    active: true,
};

export const CustomerYupSchema = Yup.object().shape({
    firstName: Yup.string().min(2, 'Too Short!').max(70, 'Too Long!').required('Required'),
    phone: Yup.string().min(10, 'Too Short!').max(70, 'Too Long!').required('Required'),
});

export default {
    CustomerDefaultProps,
    CustomerPropTypes,
    CustomerYupSchema,
};
